import { useState } from "react";
import { Sparkles, Layers } from "lucide-react";
import { LAYERS } from "../site";
import GummyBurger from "./GummyBurger";

export default function LayerWidget() {
  const [exploded, setExploded] = useState(false);
  const [selected, setSelected] = useState("bun-top");
  const active = LAYERS.find((l) => l.id === selected) || LAYERS[0];

  const pick = (id) => {
    setSelected(id);
    setExploded(true);
  };

  return (
    <div
      data-testid="layer-widget"
      className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16"
    >
      <div className="relative flex justify-center">
        <div
          aria-hidden="true"
          className="absolute inset-0 -z-10 mx-auto my-auto h-64 w-64 rounded-full bg-cheese/40 blur-3xl sm:h-80 sm:w-80"
        />
        <GummyBurger
          exploded={exploded}
          selected={selected}
          onSelectLayer={pick}
          className="w-full max-w-sm animate-float"
          title="Ilustrasi interaktif lapisan gummy Yupi Burger"
        />
      </div>

      <div>
        <div className="flex flex-wrap gap-2" role="group" aria-label="Pilih lapisan gummy">
          {LAYERS.map((layer) => (
            <button
              key={layer.id}
              type="button"
              data-testid={layer.testid}
              aria-pressed={selected === layer.id}
              onClick={() => pick(layer.id)}
              className={`rounded-full border-2 px-4 py-2 font-display text-sm font-semibold transition-all duration-200 hover:scale-105 active:scale-95 ${
                selected === layer.id
                  ? "border-plum bg-plum text-white"
                  : "border-plum/15 bg-white text-plum hover:border-plum/40"
              }`}
            >
              <span
                aria-hidden="true"
                className="mr-2 inline-block h-3 w-3 rounded-full align-middle"
                style={{ backgroundColor: layer.color }}
              />
              {layer.name}
            </button>
          ))}
        </div>

        <div
          data-testid="layer-widget-info-panel"
          className="mt-6 rounded-3xl border-2 border-plum/10 bg-white p-6 shadow-gummy sm:p-7"
        >
          <h3 className="font-display text-xl font-bold text-plum sm:text-2xl">{active.name}</h3>
          <p className="mt-3 text-sm leading-relaxed text-plum-soft sm:text-base">
            <span className="font-bold text-plum">Rasa:</span> {active.flavor}
          </p>
          <p className="mt-2 flex items-start gap-2 text-sm leading-relaxed text-plum-soft sm:text-base">
            <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-bun-dark" aria-hidden="true" />
            <span>
              <span className="font-bold text-plum">Fakta seru:</span> {active.fact}
            </span>
          </p>
        </div>

        <button
          type="button"
          data-testid="layer-widget-toggle-explode"
          aria-pressed={exploded}
          onClick={() => setExploded((v) => !v)}
          className="btn-primary mt-6"
        >
          <Layers className="h-5 w-5" aria-hidden="true" />
          {exploded ? "Susun Lagi Burger-nya" : "Lepas Lapis Demi Lapis!"}
        </button>
      </div>
    </div>
  );
}
